const env = {
    emailJSPublicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '',
    emailJSServiceId: process.env.REACT_APP_EMAILJS_SERVICE_ID || '',
    emailJSTemplateId: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '',
};

export default env;
